import {useEffect, useState} from "react";
import {APIv1} from "../../api";

const isFailedLog = (record) => {
    const statusFlag = record.isSuccess ?? record.is_success;
    return statusFlag === false || statusFlag === 'false' || statusFlag === 'False' || statusFlag === 0 || statusFlag === '0';
};

const getPaymentLogId = (record) => record.id ?? record.pk;

const getInitialContent = (record) => record.paymentResponse ?? record.confirmResponse;

export default function LogsExpandedRow({record, token}) {
    const [responseContent, setResponseContent] = useState(null);
    const paymentLogId = getPaymentLogId(record);
    const shouldFetchContent = isFailedLog(record) && paymentLogId && paymentLogId !== 'Unknown' && Boolean(token);

    useEffect(() => {
        const fetchResponseContent = async () => {
            if (!shouldFetchContent) return;

            try {
                const response = await APIv1.get(`payment/logs/response/content/?idx=${encodeURIComponent(paymentLogId)}`, {
                    headers: {
                        Authorization: `Token ${token}`,
                    },
                });

                setResponseContent(response.data?.data?.payment ?? response.data?.data?.confirm);
            } catch (err) {
                console.error('Something went wrong:', err);
            }
        };

        fetchResponseContent();
    }, [paymentLogId, shouldFetchContent, token]);

    return (
        <p style={{margin: 0}}>
            {responseContent ?? getInitialContent(record)}
        </p>
    );
}
